import { render, staticRenderFns } from "./ThemeSettingsDirectRight.vue?vue&type=template&id=73c1b343&scoped=true"
import script from "./ThemeSettingsDirectRight.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c1b343",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c1b343')) {
      api.createRecord('73c1b343', component.options)
    } else {
      api.reload('73c1b343', component.options)
    }
    module.hot.accept("./ThemeSettingsDirectRight.vue?vue&type=template&id=73c1b343&scoped=true", function () {
      api.rerender('73c1b343', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/themes/ThemeSettingsDirectRight.vue"
export default component.exports